/** @file This file contains utils to deal with APIs. */
import { Maybe } from 'purify-ts';
/**
 * Load all paginated pages, yielded per page.
 *
 * @param load The function to load the next page.
 * @yields All the data of the paginated response, yielded per page.
 */
export async function* loadAllPagesPerPage(load) {
    let page = await load(Maybe.empty());
    yield page.data;
    while (page.nextToken != null) {
        // eslint-disable-next-line no-await-in-loop
        page = await load(Maybe.of(page.nextToken));
        yield page.data;
    }
}
/**
 * Load all paginated pages.
 *
 * This is the same as `loadAllPagesPerPage` but then it yields per element, not per page.
 *
 * @param load The function to load the next page.
 * @yields The data for all pages, determined by when `load` returns an empty `nextToken`.
 */
export async function* loadAllPages(load) {
    for await (const page of loadAllPagesPerPage(load)) {
        yield* page;
    }
}
